import React from 'react';
import { Phone, Mail, MapPin, Facebook, Clock, ArrowRight } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-900 text-gray-300 pt-24 pb-12 border-t border-white/10" data-id="element-111">
      <div className="max-w-7xl mx-auto px-4" data-id="element-112">
        {/* Top Row CTA */}
        <div className="bg-navy-800 rounded-2xl p-8 md:p-12 mb-16 border border-white/5 flex flex-col lg:flex-row items-center justify-between gap-8" data-id="element-113">
          <div className="max-w-xl" data-id="element-114">
            <h3 className="text-2xl font-heading font-extrabold text-white mb-2" data-id="element-115">
              Need an Electrician Now?
            </h3>
            <p className="text-gray-300" data-id="element-116">
              We're ready to help with any electrical issue, big or small.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto" data-id="element-117">
            <a href="tel:0418381988" className="bg-accent hover:bg-accent-600 text-white px-8 py-4 rounded-xl font-extrabold text-lg flex items-center justify-center gap-2 transition-colors" data-id="element-118">
              <Phone className="w-5 h-5" data-id="element-119" />
              0418 381 988
            </a>
            <a href="#quote" className="bg-white/10 hover:bg-white/20 text-white border border-white/10 px-8 py-4 rounded-xl font-extrabold text-lg flex items-center justify-center gap-2 transition-colors" data-id="element-120">
              Book Online
              <ArrowRight className="w-5 h-5" data-id="element-121" />
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16" data-id="element-122">
          {/* Brand Col */}
          <div className="space-y-8 lg:col-span-2" data-id="element-123">
            <img src="https://cdn.magicpatterns.com/uploads/keXDJJ6XdrR4HdR9pRaeSp/pasted-image.png" alt="Completely Electrical" className="h-14" data-id="element-124" />
            <p className="text-base leading-relaxed text-gray-300 max-w-md" data-id="element-125">
              Perth's South Of River electrician. Brodie Morrison and team have
              been delivering quality residential, commercial and industrial
              electrical work since 2020. ABN 40 434 878 561. Member of Master
              Electricians AU, to be confirmed.
            </p>
            <div className="flex gap-4" data-id="element-126">
              <a href="#" className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center hover:bg-accent hover:text-white transition-colors border border-white/10 hover:border-accent" data-id="element-127">
                <Facebook className="w-5 h-5" data-id="element-128" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-129">
            <h4 className="text-white font-heading font-extrabold text-xl mb-6" data-id="element-130">
              Quick Links
            </h4>
            <ul className="space-y-4 text-base font-medium" data-id="element-131">
              <li data-id="element-132">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-133">
                  Home
                </a>
              </li>
              <li data-id="element-134">
                <a href="#about" className="hover:text-accent transition-colors" data-id="element-135">
                  About Us
                </a>
              </li>
              <li data-id="element-136">
                <a href="#services" className="hover:text-accent transition-colors" data-id="element-137">
                  Services
                </a>
              </li>
              <li data-id="element-138">
                <a href="#emergency" className="text-red-400 hover:text-red-300 transition-colors font-bold" data-id="element-139">
                  After-hours emergency
                </a>
              </li>
              <li data-id="element-140">
                <a href="#contact" className="hover:text-accent transition-colors" data-id="element-141">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-142">
            <h4 className="text-white font-heading font-extrabold text-xl mb-6" data-id="element-143">
              Core Services
            </h4>
            <ul className="space-y-4 text-base font-medium" data-id="element-144">
              <li data-id="element-145">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-146">
                  Air Conditioning
                </a>
              </li>
              <li data-id="element-147">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-148">
                  Lighting Upgrades
                </a>
              </li>
              <li data-id="element-149">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-150">
                  Hot Water Systems
                </a>
              </li>
              <li data-id="element-151">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-152">
                  Fault Finding
                </a>
              </li>
              <li data-id="element-153">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-154">
                  Switchboard Upgrades
                </a>
              </li>
              <li data-id="element-155">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-156">
                  Commercial Electrical
                </a>
              </li>
              <li data-id="element-157">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-158">
                  Compliance Checks
                </a>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div data-id="element-159">
            <h4 className="text-white font-heading font-extrabold text-xl mb-6" data-id="element-160">
              Service Areas
            </h4>
            <ul className="space-y-4 text-base font-medium" data-id="element-161">
              <li data-id="element-162">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-163">
                  Huntingdale
                </a>
              </li>
              <li data-id="element-164">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-165">
                  Gosnells
                </a>
              </li>
              <li data-id="element-166">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-167">
                  Thornlie
                </a>
              </li>
              <li data-id="element-168">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-169">
                  Southern River
                </a>
              </li>
              <li data-id="element-170">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-171">
                  Harrisdale
                </a>
              </li>
              <li data-id="element-172">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-173">
                  Maddington
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Contact Details Row */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 py-10 border-t border-white/10 mb-10" data-id="element-174">
          <div className="flex items-start gap-4" data-id="element-175">
            <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0" data-id="element-176">
              <Phone className="w-6 h-6 text-accent" data-id="element-177" />
            </div>
            <div data-id="element-178">
              <span className="block text-sm text-gray-300 font-bold uppercase tracking-wider mb-1" data-id="element-179">
                Call Us
              </span>
              <a href="tel:0418381988" className="text-white font-extrabold hover:text-accent transition-colors text-xl" data-id="element-180">
                0418 381 988
              </a>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-181">
            <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0" data-id="element-182">
              <Mail className="w-6 h-6 text-accent" data-id="element-183" />
            </div>
            <div data-id="element-184">
              <span className="block text-sm text-gray-300 font-bold uppercase tracking-wider mb-1" data-id="element-185">
                Email Us
              </span>
              <a href="mailto:brodie@completelyelectrical.net" className="text-white font-medium hover:text-accent transition-colors text-base" data-id="element-186">
                brodie@completelyelectrical.net
              </a>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-187">
            <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0" data-id="element-188">
              <MapPin className="w-6 h-6 text-accent" data-id="element-189" />
            </div>
            <div data-id="element-190">
              <span className="block text-sm text-gray-300 font-bold uppercase tracking-wider mb-1" data-id="element-191">
                Location
              </span>
              <span className="text-white font-medium text-base" data-id="element-192">
                Huntingdale Rd,
                <br data-id="element-193" />
                Huntingdale WA 6110
              </span>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-194">
            <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0" data-id="element-195">
              <Clock className="w-6 h-6 text-accent" data-id="element-196" />
            </div>
            <div data-id="element-197">
              <span className="block text-sm text-gray-300 font-bold uppercase tracking-wider mb-1" data-id="element-198">
                Hours
              </span>
              <span className="text-white font-medium text-base block" data-id="element-199">
                Standard Hours
              </span>
              <span className="text-red-400 font-bold text-base block mt-0.5" data-id="element-200">
                After-hours emergency available
              </span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-sm font-medium text-gray-300" data-id="element-201">
          <p data-id="element-202">
            &copy; {new Date().getFullYear()} Completely Electrical. All rights
            reserved.
          </p>
          <div className="flex flex-wrap items-center gap-4 justify-center" data-id="element-203">
            <span className="bg-white/5 px-3 py-1 rounded-md border border-white/10" data-id="element-204">
              Fully Licensed & Insured
            </span>
          </div>
          <div className="flex gap-6" data-id="element-205">
            <a href="#" className="hover:text-white transition-colors" data-id="element-206">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-207">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}